module.exports = __webpack_public_path__ + "img/bh_2.ac370658.jpg";